import { useQuery } from '@tanstack/react-query';
import { fetchWaiverRequests } from '../../services/waivers';

function useGetCustomerForms({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['customer-forms-tab', { customerId, businessId }],
    queryFn: () => fetchWaiverRequests({ businessId, page: 0, customerId }),
    enabled: !!customerId && !!businessId,
  });

  return {
    waiverRequests: data?.waiverRequests ?? [],
    isInitialLoading: isLoading,
    isError,
    error,
  };
}

export default useGetCustomerForms;
